import AlbaProducts from './Products/Alba.config';
import AvenyProducts from './Products/Aveny.config';
import DreamerProducts from './Products/Dreamer.config';
import HarvestProducts from './Products/Harvest.config';
import HudsonProducts from './Products/Hudson.config';
import LindoProducts from './Products/Lindo.config';
import LondonProducts from './Products/London.config';
import MiamiProducts from './Products/Miami.config';
import PausProducts from './Products/Paus.config';
import SerenityProducts from './Products/Serenity.config';
import SoulProducts from './Products/Soul.config';
import SunnyProducts from './Products/Sunny.config';
import VoyageProducts from './Products/Voyage.config';

const Products3DConfig = [].concat(AlbaProducts, AvenyProducts, DreamerProducts, HarvestProducts, HudsonProducts, LindoProducts, LondonProducts, MiamiProducts, PausProducts, SerenityProducts, SoulProducts, SunnyProducts, VoyageProducts)

export default Products3DConfig;